// extracted by mini-css-extract-plugin
export default {"file_icon_wrapper":"styles_file_icon_wrapper__7scYU","file_inner":"styles_file_inner__EOM8w"};